define(["data/config", "componentClasses/window"], function(config, Window) {
    return {
        name: "window",
        apply: function($element, params) {
            if (!params.html && !params.url && !params.target) {
                params.url = $element.attr("href");
            }

            if (params.target) {
                params.html = $element.findTarget(params.target).html();
            }

            $element.on("click", function(ev) {
                ev.preventDefault();
                new Window(params).place();
            });
        }
    };
});
